import { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function SchoolStatsChart({ schools }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const chartData = schools.map((school) => ({
      name: school.name?.length > 12 ? `${school.name.slice(0, 12)}…` : school.name,
      staff: school.stats?.totalStaff ?? 0,
    }));
    setData(chartData);
  }, [schools]);

  if (data.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-gray-500">
        No customer data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 56 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 11, fill: "#64748b" }}
          angle={-28}
          textAnchor="end"
        />
        <YAxis tick={{ fontSize: 12, fill: "#64748b" }} />
        <Tooltip
          cursor={{ fill: "rgba(0,0,0,0.03)" }}
          contentStyle={{
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 4px 20px -4px rgba(0,0,0,0.08)",
          }}
        />
        <Legend wrapperStyle={{ paddingTop: 8 }} />
        <Bar dataKey="staff" fill="#64748b" name="Staff" radius={[0, 6, 6, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
